<dspx-card-set-base-form *ngIf="isServiceWorkerReady$ | async"
                         [formServiceEndpoint]="formServiceEndpoint"
                         [templateId]="templateId"
                         [versionNo]="versionNo"
                         [model]="model"
                         formName="Job Details"
                         [entityId]="maatJobId"
                         (onFormLoad)="formLoad($event)"
                         (onModelChange)="modelChanged($event)"
                         (onDialogSubmit)="handleDialogButtonClick($event, activeDialog)"
                         (onActionButtonClick)="handleActionButtonClick($event)"
                         (onFilter)="filterData($event)"
                         (onSave)="save($event)"
                         (onCancel)="cancel($event)">
</dspx-card-set-base-form>
